"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _config = _interopRequireDefault(require("../../../../../config.json"));

var _axios = _interopRequireDefault(require("axios"));

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _moment = _interopRequireDefault(require("moment"));

var _DateConstant = require("../../../../../constants/DateConstant");

var _DataDisplayWidget = _interopRequireDefault(require("../../../../../components/shared-components/DataDisplayWidget"));

var _icons = require("@ant-design/icons");

var _TableData = _interopRequireDefault(require("./TableData"));

var _errorPage = _interopRequireDefault(require("../../../../error-views/errorPage"));

var _CardData = _interopRequireDefault(require("./CardData"));

var _RmName = _interopRequireDefault(require("../../../../../RmName.json"));

// import { useHistory } from 'react-router';
var innerwidth = window.innerWidth; // const { Search } = Input;

var Option = _antd.Select.Option;
var date = new Date();
var year = date.getFullYear();
var month = ("0" + (date.getMonth() + 1)).slice(-2);
var day = ("0" + date.getDate()).slice(-2);
var today = "".concat(year, "-").concat(month, "-").concat(day);

var Dropout = function Dropout() {
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token"); // const history = useHistory();

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      apiError = _useState4[0],
      setapiError = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      allParentData = _useState6[0],
      setAllParentData = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      allData = _useState8[0],
      setAllData = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      searchData = _useState10[0],
      setSearchData = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      allRM = _useState12[0],
      setAllRM = _useState12[1];

  var _useState13 = (0, _react.useState)([]),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      filterRM = _useState14[0],
      setFilterRM = _useState14[1];

  var _useState15 = (0, _react.useState)("All"),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      selectRM = _useState16[0],
      setSelectRM = _useState16[1];

  var _useState17 = (0, _react.useState)("All"),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      subjectData = _useState18[0],
      setSubjectData = _useState18[1];

  var _useState19 = (0, _react.useState)(undefined),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      start = _useState20[0],
      setStart = _useState20[1]; //Startdate


  var _useState21 = (0, _react.useState)(today),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      end = _useState22[0],
      setEnd = _useState22[1]; //enddate


  var SubjectList = ['Math', 'English', 'Both']; // useEffect(async () => {
  //   callStudentDetails();
  // }, []);

  (0, _react.useEffect)(function () {
    function callStudentDetails() {
      var allStudentUrl = _config.default.allStudentDetails + cl + "&status=DropOut";

      _axios.default.get(allStudentUrl, {
        headers: {
          'Authorization': token
        }
      }).then(function (resp) {
        if (resp.data.status === "error") setapiError(resp.data);else {
          resp.data.forEach(function (obj) {
            obj.Joining_date = dateFormate(obj.Joining_date);
            obj.DOB = dateFormate(obj.DOB);
            obj.Dropout_date = dateFormate(obj.Dropout_date);
          });
          var minDate = new Date(Math.min.apply(Math, (0, _toConsumableArray2.default)(resp.data.map(function (element) {
            return new Date(element.Dropout_date);
          }))));
          setStart(minDate);
          setAllParentData(resp.data);
          setAllData(resp.data);
          setSearchData(resp.data);
          setLoading(false);
        }
      }, function (err) {
        var obj = {
          "status": "error",
          "message": "Network Error"
        };
        if (err.response) setapiError(err.response);else setapiError(obj);
      });

      var allRMUrl = _config.default.listOfRMs + cl;

      _axios.default.get(allRMUrl, {
        headers: {
          'Authorization': token
        }
      }).then(function (resp) {
        if (resp.data.status === "error") setapiError(resp.data);else {
          setAllRM(resp.data);
          setFilterRM(resp.data);
          setLoading(false);
        }
      }, function (err) {
        var obj = {
          "status": "error",
          "message": "Network Error"
        };
        if (err.response) setapiError(err.response);else setapiError(obj);
      });
    }

    callStudentDetails(); // eslint-disable-next-line 
  }, []);

  function dateFormate(changeDate) {
    var date = new Date(changeDate);
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    var todayDate = "".concat(year, "-").concat(month, "-").concat(day);
    return todayDate;
  }

  var onSearch = function onSearch(e) {
    var value = e.currentTarget.value;

    var searchdata = _utils.default.wildCardSearch(searchData, value);

    setAllData(searchdata);
    var rmList = searchdata.reduce(function (unique, o) {
      if (!unique.some(function (obj) {
        return obj.RM_code === o.RM_code;
      })) {
        unique.push(o);
      }

      return unique;
    }, []);
    setFilterRM(rmList);
  };

  var handleShowRM = function handleShowRM(value) {
    var details = showTableData("Subject");
    setSelectRM(value);

    if (value !== 'All') {
      var key = 'RM_code';

      var data = _utils.default.filterArray(details, key, value);

      setAllData(data);
      setSearchData(data);
      var rmList = data.reduce(function (unique, o) {
        if (!unique.some(function (obj) {
          return obj.RM_code === o.RM_code;
        })) {
          unique.push(o);
        }

        return unique;
      }, []);
      setFilterRM(rmList);
    } else {
      setAllData(details);
      setSearchData(details);
      setFilterRM(allRM);
    }
  };

  var handleShowSubject = function handleShowSubject(value) {
    var details = showTableData("Status");
    setSubjectData(value);

    if (value !== 'All') {
      var key = 'Subject';

      var data = _utils.default.filterArray(details, key, value);

      setAllData(data);
      setSearchData(data);
      var rmList = data.reduce(function (unique, o) {
        if (!unique.some(function (obj) {
          return obj.RM_code === o.RM_code;
        })) {
          unique.push(o);
        }

        return unique;
      }, []);
      setFilterRM(rmList);
    } else {
      setAllData(details);
      setSearchData(details);
      setFilterRM(allRM);
    }
  };

  function filterDate(str, dateString) {
    var details = showTableData("Status");

    if (str === "end" && dateString) {
      setEnd(dateString);
      start = typeof start === "object" ? dateFormate(start) : start;
      setStart(start);
      var filterData = details.filter(function (obj) {
        return obj.Dropout_date >= start && obj.Dropout_date <= dateString;
      });
      var rmList = filterData.reduce(function (unique, o) {
        if (!unique.some(function (obj) {
          return obj.RM_code === o.RM_code;
        })) {
          unique.push(o);
        }

        return unique;
      }, []);
      setFilterRM(rmList);
      setAllData(filterData);
      setSearchData(filterData);
    } else if (str === "start" && dateString) {
      setStart(dateString);

      var _filterData = details.filter(function (obj) {
        return obj.Dropout_date >= dateString && obj.Dropout_date <= end;
      });

      var _rmList = _filterData.reduce(function (unique, o) {
        if (!unique.some(function (obj) {
          return obj.RM_code === o.RM_code;
        })) {
          unique.push(o);
        }

        return unique;
      }, []);

      setFilterRM(_rmList);
      setAllData(_filterData);
      setSearchData(_filterData);
    } else {
      setAllData(details);
      setSearchData(details);
    }
  }

  function showTableData(str) {
    start = typeof start === "object" ? dateFormate(start) : start;
    setStart(start);
    var data = str === "date" ? allParentData : allParentData.filter(function (obj) {
      return obj.Dropout_date >= start && obj.Dropout_date <= end;
    });

    if (str === "Subject" || str === "date") {
      if (subjectData !== "All") {
        data = _utils.default.filterArray(data, str, subjectData);
      }
    }

    if (str === "Status" || str === "date") {
      if (selectRM !== "All") {
        data = _utils.default.filterArray(data, 'RM_code', selectRM);
      }
    }

    return data;
  }

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 16,
    xl: 16,
    xxl: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Filter"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [8, 8]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 9,
    xl: 9,
    xxl: 9
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Search",
    style: {
      width: '90%'
    },
    prefix: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, null),
    onChange: function onChange(e) {
      return onSearch(e);
    }
  })), start ? /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 15,
    xl: 15,
    xxl: 15
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("b", null, "Date From : ")), /*#__PURE__*/_react.default.createElement(_antd.DatePicker, {
    defaultValue: (0, _moment.default)(start, _DateConstant.DATE_FORMAT_YYYY_MM_dd),
    onChange: function onChange(momentDate, dateString) {
      return filterDate("start", dateString);
    },
    placeholder: "Select Start Date"
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("b", null, "\xA0To : ")), /*#__PURE__*/_react.default.createElement(_antd.DatePicker, {
    defaultValue: (0, _moment.default)(date, _DateConstant.DATE_FORMAT_YYYY_MM_dd_Combined),
    onChange: function onChange(momentDate, dateString) {
      return filterDate("end", dateString);
    },
    placeholder: "Select End Date"
  })))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    className: "mt-2",
    xs: 12,
    sm: 12,
    md: 12,
    lg: 9,
    xl: 9,
    xxl: 9
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("b", null, _RmName.default.nameCode, ": ")), "\xA0", /*#__PURE__*/_react.default.createElement(_antd.Select, {
    showSearch: true,
    style: {
      width: '90%'
    },
    placeholder: "Search or Select ".concat(_RmName.default.nameCode),
    optionFilterProp: "children",
    filterOption: function filterOption(input, option) {
      return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    filterSort: function filterSort(optionA, optionB) {
      return optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase());
    },
    onChange: handleShowRM
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "All"
  }, "All"), allRM.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: item,
      value: item
    }, item);
  }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    className: "mt-2",
    xs: 12,
    sm: 12,
    md: 12,
    lg: 15,
    xl: 15,
    xxl: 15
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("b", null, "Subject: ")), "\xA0", /*#__PURE__*/_react.default.createElement(_antd.Select, {
    style: {
      width: '90%'
    },
    defaultValue: "All",
    onChange: handleShowSubject
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "All"
  }, "All"), SubjectList.map(function (elm) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: elm,
      value: elm
    }, elm);
  })))))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 4,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_DataDisplayWidget.default, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserSwitchOutlined, null),
    value: allData.length,
    title: "Total Student",
    color: "cyan",
    size: "20",
    vertical: true,
    avatarSize: 30,
    cardHeight: 185
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 4,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_DataDisplayWidget.default, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserSwitchOutlined, null),
    value: filterRM.length,
    title: "Total ".concat(_RmName.default.name),
    color: "volcano",
    size: "20",
    vertical: true,
    avatarSize: 30,
    cardHeight: 185
  }))), innerwidth > 425 ? /*#__PURE__*/_react.default.createElement(_TableData.default, {
    data: allData
  }) : /*#__PURE__*/_react.default.createElement(_CardData.default, {
    data: allData
  }));
};

var _default = Dropout;
exports.default = _default;